import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { _ as _objectSpread2 } from '../../../dist/objectSpread2-811c5212.esm.js';
import { useContext } from 'react';
import { path, unpick, mapObj } from '../../../obj/dist/uswitch-ev-utils-obj.esm.js';
import { contentTypeId } from '../../../contentful/dist/uswitch-ev-utils-contentful.esm.js';
import { whenNotNil } from '../../../nil/dist/uswitch-ev-utils-nil.esm.js';
import { EVTrackingContext, EVCDataContext, EVCOptionsContext, SlimlineContext, EVCComponentContext } from '../../provider/dist/uswitch-ev-utils-context-provider.esm.js';
import 'react-chansey';
import { useExperiences as useExperiences$1 } from 'react-chansey/lib/provider';
import { forceHydration, debugHydration } from '../../../helpers/env/dist/uswitch-ev-utils-helpers-env.esm.js';
import '@babel/runtime/helpers/defineProperty';
import '@babel/runtime/helpers/typeof';
import '@babel/runtime/helpers/asyncToGenerator';
import '@babel/runtime/regenerator';
import '../../../conditional-wrapper/dist/uswitch-ev-utils-conditional-wrapper.esm.js';
import 'theme-ui/jsx-runtime';

var _excluded = ["variations", "wrapperConfig", "features"];
var MODES = {
  TEST: 'test',
  DEBUG: 'debug'
};
var Slimcludes = [];
var useBrand = function useBrand() {
  var _useMeta;
  return (_useMeta = useMeta(['brand'])) === null || _useMeta === void 0 ? void 0 : _useMeta.toLowerCase();
};
var useExperiences = useExperiences$1;
var useTracking = function useTracking() {
  return useContext(EVTrackingContext).track;
};
var useTrackAll = function useTrackAll() {
  return useContext(EVTrackingContext).client.trackAll;
};
var useDataSelector = function useDataSelector() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (i) {
    return i;
  };
  var defaultValue = arguments.length > 1 ? arguments[1] : undefined;
  var data = useContext(EVCDataContext);
  if (typeof s === 'function') whenNotNil(s(data), defaultValue);
  if (Array.isArray(s)) return path(s, data, defaultValue);
  return data;
};
var useDoHydrate = function useDoHydrate() {
  return useDataSelector(['toHydrate'], []);
};
var useForceHydration = function useForceHydration() {
  return useDataSelector(['forceHydration'], forceHydration);
};
var useDebugHydration = function useDebugHydration() {
  return useDataSelector(['debugHydration'], debugHydration);
};
var useDoHydrateComponent = function useDoHydrateComponent(id) {
  var doHydrateIds = useDoHydrate();
  var forceHydration = useForceHydration();
  var doHydrate = forceHydration || doHydrateIds.includes(id);
  return doHydrate;
};
var useDontLazyload = function useDontLazyload() {
  return useDataSelector(['dontLazyLoad'], false);
};
var useIncludes = function useIncludes(_) {
  return useDataSelector(['includes']);
};
var useTestMode = function useTestMode() {
  var mode = useDataSelector(['mode']);
  return [mode, MODES];
};
var useOptions = function useOptions() {
  var Options = useContext(EVCOptionsContext);
  return Options;
};
var getEntity = function getEntity(props) {
  var includes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (Object.keys(includes).length === 0) {
    console.log('empty includes');
  }
  var id = path(['id'], props) || path(['sys', 'id'], props);
  var entity = path([id], includes);
  if (id && !entity) {
    console.log("No entity in getEntity hook for id: ".concat(id));
    return {
      err: "ENOENTITY: unable to find entity for id ".concat(id, " in getEntity")
    };
  }
  return entity ? _objectSpread2(_objectSpread2(_objectSpread2({}, props), entity.fields), {}, {
    sys: entity.sys
  }) : {};
};
var useEntity = function useEntity(props) {
  return getEntity(props, useIncludes());
};
var useEntities = function useEntities(entries) {
  return entries.map(useEntity);
};
var usePalette = function usePalette(palette) {
  var Slimline = useContext(SlimlineContext);
  var includes = useIncludes();
  var styles = unpick(['name', 'sys'], useEntity(palette));
  return mapObj(function (color) {
    var id = path(['sys', 'id'], color);
    Slimline.push(id);
    var hexcode = path([id, 'fields', 'hexcode'], includes);
    return "#".concat(hexcode);
  }, styles);
};
var firstValidFlag = function firstValidFlag(map) {
  var experiences = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return Object.entries(flags).find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      flag = _ref2[0],
      variant = _ref2[1];
    if (!Object.prototype.hasOwnProperty.call(experiences, flag)) {
      return false;
    }
    if (typeof experiences[flag].value !== 'boolean') {
      console.error("EINVALIDCONFIG: invalid flag ".concat(flag, " used in meta when rendering - not boolean"));
      return false;
    }
    return experiences[flag].value === true && map[variant];
  });
};
var useComponent = function useComponent() {
  var _props$sys;
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var flagState = useMeta('releaseFlags');
  var experiences = useExperiences();

  // TODO: fix that below
  var cMap = useContext(EVCComponentContext);
  if (cMap.EVCoreDefaultComponents) {
    cMap = cMap.EVCoreDefaultComponents;
  }
  var componentId = props.tag || contentTypeId(props);
  var component = cMap[componentId];
  if (!component) return ["ENOCOMPONENT: unable to find component ID in ".concat(props === null || props === void 0 ? void 0 : (_props$sys = props.sys) === null || _props$sys === void 0 ? void 0 : _props$sys.contentTypeId)];
  if (component && component.variations) {
    var _component$features, _component$features2;
    var componentMap = component.variations;
    if (!componentMap.default) {
      return ["EINVALIDCONFIG: invalid config for ".concat(componentId, " - missing default map")];
    }
    var _ref3 = firstValidFlag(componentMap, experiences, flagState) || [],
      _ref4 = _slicedToArray(_ref3, 2),
      variant = _ref4[1];
    component.variations;
      component.wrapperConfig;
      component.features;
      var config = _objectWithoutProperties(component, _excluded);
    return variant ? [null, componentMap[variant], component.wrapperConfig, (_component$features = component.features) !== null && _component$features !== void 0 ? _component$features : {}, config] : [null, componentMap.default, component.wrapperConfig, (_component$features2 = component.features) !== null && _component$features2 !== void 0 ? _component$features2 : {}, config];
  }
  return ["ENOCOMPONENT: unable to find component for ".concat([props.tag, contentTypeId(props)].filter(function (i) {
    return i;
  }).join('||'))];
};
var useComponentMeta = function useComponentMeta(component, variant) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var path = variant ? [component, variant] : [component];
  return useMeta(path, defaultValue);
};
var useMeta = function useMeta(path, defaultValue) {
  return useDataSelector(['meta'].concat(path), defaultValue);
};

export { Slimcludes, getEntity, useBrand, useComponent, useComponentMeta, useDataSelector, useDebugHydration, useDoHydrate, useDoHydrateComponent, useDontLazyload, useEntities, useEntity, useExperiences, useForceHydration, useIncludes, useMeta, useOptions, usePalette, useTestMode, useTrackAll, useTracking };
